var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("h6", { staticClass: "q-mb-sm q-title" }, [
      _vm._v(_vm._s(_vm.$t("invite_more")))
    ]),
    _c(
      "div",
      { staticClass: "row gutter-x-lg items-center" },
      [
        _c(
          "q-field",
          {
            staticClass: "col-12 col-md",
            attrs: {
              error: _vm.errors.has("inviteEmail"),
              "error-label": _vm.errors.first("inviteEmail")
            }
          },
          [
            _c("q-input", {
              directives: [
                {
                  name: "validate",
                  rawName: "v-validate.disable",
                  value: "required|email|max:255",
                  expression: "'required|email|max:255'",
                  modifiers: { disable: true }
                }
              ],
              attrs: {
                type: "input",
                name: "inviteEmail",
                "data-vv-as": _vm.$t("email"),
                "float-label": _vm.$t("email")
              },
              model: {
                value: _vm.invite.email,
                callback: function($$v) {
                  _vm.$set(
                    _vm.invite,
                    "email",
                    typeof $$v === "string" ? $$v.trim() : $$v
                  )
                },
                expression: "invite.email"
              }
            })
          ],
          1
        ),
        _c(
          "q-field",
          {
            staticClass: "col-12 col-md",
            attrs: {
              error: _vm.errors.has("inviteName"),
              "error-label": _vm.errors.first("inviteName")
            }
          },
          [
            _c("q-input", {
              directives: [
                {
                  name: "validate",
                  rawName: "v-validate.disable",
                  value: "max:255",
                  expression: "'max:255'",
                  modifiers: { disable: true }
                }
              ],
              attrs: {
                name: "inviteName",
                "data-vv-as": _vm.$t("person_name"),
                "float-label": _vm.$t("person_name")
              },
              model: {
                value: _vm.invite.name,
                callback: function($$v) {
                  _vm.$set(_vm.invite, "name", $$v)
                },
                expression: "invite.name"
              }
            })
          ],
          1
        ),
        _c(
          "q-field",
          { staticClass: "col-12 col-md" },
          [
            _c("q-select", {
              attrs: {
                type: "radio",
                options: _vm.possibleRoles,
                "float-label": _vm.$t("role")
              },
              model: {
                value: _vm.invite.roleId,
                callback: function($$v) {
                  _vm.$set(_vm.invite, "roleId", $$v)
                },
                expression: "invite.roleId"
              }
            })
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col-12 col-md-auto" },
          [
            _c(
              "q-btn",
              {
                staticClass: "team-invite__add-button",
                attrs: {
                  color: "secondary",
                  loading: _vm.loading,
                  outline: ""
                },
                on: { click: _vm.handleSendInvite }
              },
              [
                _vm._v(
                  "\n        " + _vm._s(_vm.$t("send_invite")) + "\n      "
                )
              ]
            )
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }